import React, { useState } from "react";
import { Link } from "react-router-dom";

const { portValidator } = require("port-validator");
const OverallSelectedform1 = (props) => {
  const {
    headerUD,
    selectedtags,
    userdatatags,
    selectalltagsstatus,
    selectUserdatacisno,
    setAssignuserdata,
    assignuserdata,
    backup,
  } = props;

  const [userdata, setUserdata] = useState([]);

  const [newstate, setNewstate] = useState([]);

  const handleChange = (e) => {
    const { id, value } = e.target;
    setNewstate((prevState) => ({
      ...prevState,
      [id]: value,
    }));
    setAssignuserdata((prevState) => ({
      ...prevState,
      [id]: value,
    }));
  };

  const Submit = () => (e) => {
    e.preventDefault();
    var value1 = JSON.stringify(newstate);
    const taglist = selectedtags.toString();
    console.log(taglist);
    window.localStorage.setItem("access_userdata", "checked");
    let sub = {
      temp_id: window.sessionStorage.getItem("TempID").toString(),
      taglist: selectedtags.toString(),
    };
    const temp_id = window.sessionStorage.getItem("TempID");
    fetch(`${process.env.REACT_APP_API_URL}/api/run_temp/${temp_id}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + window.localStorage.getItem("token"),
      },
      body: JSON.stringify(sub),
    })
      .then((response) => response.json())
      .then((data) => {
        window.sessionStorage.setItem("access_userdata", "notchecked");
        window.sessionStorage.removeItem("userdata");
      })
      .catch((error) => {
        console.log(error);
        window.sessionStorage.setItem("access_userdata", "notchecked");
        window.sessionStorage.removeItem("userdata");
      });
  };

  const [open, setOpen] = React.useState(false);

  const handleSaveandClose = (e) => {
    e.preventDefault();
    Submit();
    setOpen(false);
  };

  const [visible, setVisible] = useState(true);

  const onDismiss = () => setVisible(false);

  const handleClose = (e) => {
    e.preventDefault();
    setOpen(false);
  };
  const [popovercheck, setPopovercheck] = useState();
  const [checkbackup, setCheckbackup] = useState(false);

  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = (event, name, number) => {
    setPopovercheck(number);
    sessionStorage.setItem("hintValue", name);
    setAnchorEl(event.currentTarget);
  };

  const oneClose = () => {
    setAnchorEl(null);
  };

  const two = Boolean(anchorEl);
  const id = two ? "simple-popover" : undefined;

  return (
    <>
      <div>
        <button
          className="bg-blueGray-600 text-white active:bg-lightBlue-600 font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150"
          type="button"
          style={{ float: "right" }}
        >
          <Link
            to={{
              pathname: "/admin/templates",
            }}
          >
            Cancel
          </Link>
        </button>

        <button
          className="bg-lightBlue-500 text-white active:bg-lightBlue-600 font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150"
          size="sm"
          onClick={Submit(selectedtags)}
          style={{ float: "right" }}
          disabled={selectedtags.length > 0 ? false : true}
        >
          <Link
            to={{
              pathname: "/admin/templates",
            }}
          >
            Save
          </Link>
        </button>
      </div>
    </>
  );
};

export default OverallSelectedform1;